// Dependences
import axios from 'axios'
import env from '@/env'
export default() => {
  return axios.create({
    baseURL: env.API_BASE_URL
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js